import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {ActionRequiredOrdersResult} from '../types/ActionRequiredOrdersResult';

export const useGetActionRequiredOrders = (actionRequiredID?: number,
    pendingOnly?: boolean, pastDueOnly?: boolean, activeOnly?: boolean) => {
    const { data, isLoading } = useQuery({
        queryKey: ['cfi-action-required-orders', actionRequiredID, pendingOnly, pastDueOnly],
        queryFn: async () => await apiClient.get('action-required/cfi-orders',
            {
                params: {
                    actionRequiredID: actionRequiredID,
                    pendingOnly: pendingOnly,
                    pastDueOnly: pastDueOnly,
                    activeOnly: activeOnly
                }
            }) as ActionRequiredOrdersResult
    });

    return {
        data,
        isLoading
    };
};
